import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import Portal from "@material-ui/core/Portal";

const LoginBackground = withStyles(
  {
    overlay: {
      background: "rgba(0,0,0,0.05)",
      pointerEvents: "none",
      position: "fixed",
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      backgroundSize: "100% 100%",
      backgroundRepeat: "no-repeat"
    },
    video: {
      position: "fixed",
      top: 0,
      left: 0,
      overflow: "hidden",
      minWidth: "100%",
      minHeight: "100%",
      objectFit: "fill"
    }
  },
  { name: "LoginBackground" }
)(
  ({
    webm,
    mp4,
    ogv,
    img,
    classes: { overlay, video },
    container = document.body.children[1]
  }) =>
    webm || mp4 || ogv ? (
      <Portal container={container}>
        <div
          className={overlay}
          style={{
            backgroundImage: img ? "url(" + img + ")" : undefined
          }}
        >
          <video autoPlay muted loop id="vid" className={video}>
            {webm && <source src={webm} />}
            {mp4 && <source src={mp4} />}
            {ogv && <source src={ogv} />}
          </video>
        </div>
      </Portal>
    ) : null
);

export default LoginBackground;
